import store from '@state/store'
import lazyLoadView from './lazyload-view'
import routesLogin from '@router/routes-login'
import routesMember from '@router/routes-member'
import routesOrder from '@router/routes-order'
import routesBooking from '@router/routes-booking'
import routesCheckout from '@router/routes-checkout'

export default [
  ...routesLogin,
  {
    path: '/subscription',
    name: 'subscription',
    component: () => lazyLoadView(import('@views/subscription')),
    meta: {
      showDingSomethingLogo: false,
      showLoginButton: false,
      showShareButton: false,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('merchant/fetchPlans').then(() => next())
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    meta: {
      showDingSomethingLogo: false,
      showLoginButton: false,
      showShareButton: false,
    },
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: '/',
    redirect: '/wude',
  },
  ...routesMember,
  ...routesOrder,
  ...routesBooking,
  ...routesCheckout,
  {
    path: '*',
    redirect: '404',
  },
]
